import React from "react";

import { PopoverContext } from "@components/organisms/popover/popoverContext";

export function usePopoverContext() {
  const context = React.useContext(PopoverContext);

  if (context == null) {
    throw new Error("Popover components must be wrapped in <Popover />");
  }

  return context;
}
